<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" dark class="mb-2" @click="newEdit">休憩時間</v-btn>
    </template>
    <v-card>
      <v-dialog v-model="editDialog" persistent max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">勤務パターン編集</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs9>
                  <v-checkbox
                    v-model.number="is_rest_time_auto_insert"
                    label="退勤時、設定した休憩時間を打刻する"
                    :true-value="1"
                    :false-value="0"
                    color="success"
                  />
                </v-flex>
                <v-flex xs3>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon color="primary" dark v-on="on" style="margin-top: 0.8em">help_outline</v-icon>
                    </template>
                    <span>出勤が打刻されていない、もしくは１つでも<br>休憩の打刻がされていれば自動打刻されません。</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs12>
                  <v-dialog
                    :disabled="is_rest_time_auto_insert === 0"
                    ref="beginTimeDialog"
                    v-model="editedBeginTimeModal"
                    :return-value.sync="begin_rest_time"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="begin_rest_time"
                        :disabled="is_rest_time_auto_insert === 0"
                        label="休憩開始時刻"
                        prepend-icon="access_time"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="editedBeginTimeModal"
                      v-model="begin_rest_time"
                      full-width
                      format="24hr"
                    >
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="editedBeginTimeModal = false">Cancel</v-btn>
                      <v-btn flat color="success" @click="$refs.beginTimeDialog.save(begin_rest_time)">OK</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs12>
                  <v-dialog
                    :disabled="is_rest_time_auto_insert === 0"
                    ref="endTimeDialog"
                    v-model="editedEndTimeModal"
                    :return-value.sync="end_rest_time"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :disabled="is_rest_time_auto_insert === 0"
                        v-model="end_rest_time"
                        label="休憩終了時刻"
                        prepend-icon="access_time"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="editedEndTimeModal"
                      v-model="end_rest_time"
                      full-width
                      format="24hr"
                    >
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="editedEndTimeModal = false">Cancel</v-btn>
                      <v-btn flat color="success" @click="$refs.endTimeDialog.save(end_rest_time)">OK</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" flat @click="editDialog = false">Cancel</v-btn>
            <v-btn color="success" flat @click="save">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import cloneDeep from 'lodash/cloneDeep'

export default {
  data: () => ({
    companyId: 0,
    is_rest_time_auto_insert: 0,
    begin_rest_time: '',
    end_rest_time: '',
    editedBeginTimeModal: false,
    editedEndTimeModal: false,
    dialog: false,
    editDialog: false,
    editedItem: {}
  }),
  mounted () {
    this.getCompanyItems()
  },
  methods: {
    getCompanyItems () {
      axios.get('/api/manager/company')
        .then((res) => {
          this.companyId = res.data['id']
          this.is_rest_time_auto_insert = res.data['is_rest_time_auto_insert']
          this.begin_rest_time = res.data['begin_rest_time']
          this.end_rest_time = res.data['end_rest_time']
        })
        .catch((error) => {
          this.errorDecision(error, '/manager', '取得エラー[getCompany]')
        })
    },
    save () {
      axios.put('/api/manager/company/',
        { is_rest_time_auto_insert: this.is_rest_time_auto_insert,
          begin_rest_time: this.begin_rest_time,
          end_rest_time: this.end_rest_time })
        .then((res) => {
          this.getCompanyItems()
          this.editDialog = false
        })
        .catch(() => {
          alert('追加登録エラー')
        })
    },
    newEdit () {
      this.editDialog = true
    },
    editItem (item) {
      this.editedItem = cloneDeep(item)
      this.editDialog = true
    }
  }
}
</script>

<style>
.v-select.v-text-field--enclosed:not(.v-text-field--single-line) .v-select__selections {
  padding-top: 0;
}
</style>
